<script>
  import { VueMaskDirective as mask } from 'v-mask'
  import ClickOut from '../../../../utils/directives/clickout'
  import Service from '../../../../domain/logs/services'
  import UPagination from '../../../_default/components/Uloc/Pagination'
  import { forEach as _forEach, debounce } from 'lodash'
  import GrvService from '../../../../domain/grv/services/index'
  import {getLabel} from '../../../../domain/grv/helpers/tipos-grv'
  import PopupViewer from '../../../_default/components/popup-viewer/PopupViewer'

  export default {
    components: {
      UPagination,
      PopupViewer
    },
    nome: 'lista-logs',
    directives: {mask, ClickOut},
    data () {
      return {
        openCFilter: false,
        showFiltros: false,
        isLoading: false,
        isLoaded: false,
        data: null,
        entityid: null,
        listaGrvs: [],
        filtroInput: {
          id: null,
          data: ''
        },
        showOptionsAutocomplete: false,
        loading: false,
        paginationLimits: [25, 50, 100],
        pagination: {
          totalPages: 0,
          totalItems: 0,
          atualPage: 1,
          limit: 25
        },
        checkeds: 0,
        checkedAll: false,
        filtros: {
          busca: '',
          data: null,
          entityid: '',
          data1: '',
          data2: ''
        },
        filterKey: '',
        sortKey: '',
        sortOrders: {'date': 1},
        prevent: {},
        dblclick: 0,
        showRespostaLog: false,
        logSelecionado: null
      }
    },
    computed: {
      filteredData: function () {
        let sortKey = this.sortKey
        let filterKey = this.filterKey && this.filterKey.toLowerCase()
        let order = this.sortOrders[sortKey] || 1
        let data = this.data
        if (filterKey) {
          data = data.filter(function (row) {
            return Object.keys(row).some(function (key) {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            })
          })
        }
        if (sortKey) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        return data
      },
      noData () {
        let data = 'data'
        if (this[data] === null) {
          return false
        }
        if (this[data].length === 0) {
          return true
        }
        return false
      },
      iconSortingDirection () {
        return this.filtros.descending ? 'up' : 'down'
      }
    },
    mounted () {
      this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    },
    activated () {
    },
    destroyed () {
    },
    methods: {
      reloadData () {
        let filters = null
        filters = {...this.filtros}
        if (this.filtros.data === 'Periodo') {
          filters = {...this.filtros}
          let {data1, data2} = filters
          if (!data1 || !data2) return
        } else {
          this.filtros.data1 = ''
          this.filtros.data2 = ''
        }
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      },

      loadData (limit, page, filtros, force) {
        this.data = null
        this.isLoading = true
        let pageNumber = this.$route.query.page
        if (pageNumber != null && typeof force === 'undefined') page = pageNumber
        Service.lista(limit, page, filtros)
          .then((response) => {
            this.isLoading = false
            this.data = response.data.arrayData
            this.pagination.atualPage = response.data.offset
            this.pagination.totalPages = response.data.totalPages
            this.pagination.totalItems = response.data.total
          })
          .catch((response) => {
            this.isLoading = false
            console.log(response)
          })
      },

      changePage (page) {
        console.log('Change page ', page)
        this.pagination.atualPage = page
        this.$router.push({name: 'logs', query: {page: page}})
        this.loadData(this.pagination.limit, page, this.montaFiltros(), true)
      },

      checkAll (o) { /* TODO: Refact / Reuse CheckALL */
        this.$nextTick(() => {
          let ca = this.checkedAll
          let _vm = this
          console.log(ca)
          if (ca === true) {
            console.log(ca, o.length)
            this.checkeds = o.length
          } else {
            this.checkeds = 0
          }
          _forEach(o, (item, key) => {
            _vm.$set(this.data, key, Object.assign({}, this.data[key], {selected: ca})) // Analisar desempenho
            // item.selected = ca
            // console.log(item)
          })
        })
      },
      lazyCheck: function (l) {
        this.$nextTick(() => {
          if (l.selected) {
            this.checkeds += 1
          } else {
            this.checkeds += -1
          }

          if (this.checkeds < this.data.length) {
            this.checkedAll = false
          } else {
            this.checkedAll = true
          }
        })
      },

      montaFiltros () {
        let filtros = this.filtros
        let mount = ''
        for (let key in filtros) {
          if (filtros.hasOwnProperty(key)) {
            const val = filtros[key]
            if (val !== null) {
              mount += `&${key}=${val}`
            }
          }
        }
        return mount
      },
      sortResults (sortKey) {
        this.filtros.descending = !this.filtros.descending
        this.filtros.sortBy = sortKey
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      },

      pesquisar: debounce(function () { // debounce para evitar fazer mais de uma requisição no key event
        let busca = this.filtros.busca
        if (this.prevent.busca === busca) {
          return
        } // previne a repetição de uma chamada de api
        this.prevent.busca = busca
        this.pagination.atualPage = 1
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      }, 500),

      submit () {
        /* eslint-disable */

        const data = JSON.parse(JSON.stringify(this.data))
        const {id} = this.filtroInput
        if (!id) {
          let {id, titulo} = this.filtroInput
          if (id !== 0 && !id) {
            const regex = new RegExp(`^${titulo.toLowerCase()}$`)
            const match = this.listaGrvs.filter(item => {
              return item.placa.toLowerCase().match(regex) || item.numero.toLowerCase().match(regex)
            })
            if (match.length) {
              data.grv = match[0].id
            } else {
              alert('Grv não encontrada')
              this.$loaderOverlay.hide()
              return
            }
          }
        } else {
          data.grv = id
        }
      },

      getListaGrvs: debounce(function () {
        this.listaGrvs = []
        this.filtroInput.id = null
        this.loading = true
        const filtro = this.filtroInput.titulo.split(' - ')[0]
        if (filtro) {
          this.setVisibilityOptionsAutocomplete(true)
          GrvService.listaSimples(this.filtroInput.titulo)
            .then(result => {
              this.listaGrvs = result.data
              this.loading = false
            })
            .catch(error => {
              console.log(error)
              alert('Erro ao carregar lista de grvs')
              this.loading = false
            })
        } else {
          this.loading = false
          this.setVisibilityOptionsAutocomplete(false)
        }
      }, 300),
      setFiltroInput (filtro) {
        this.filtroInput = {...filtro}
        this.filtroInput.titulo = `${filtro.numero} - ${filtro.placa}`
        this.filtros.entityid = filtro.id
      },
      setVisibilityOptionsAutocomplete (status) {
        setTimeout(() => {
          this.showOptionsAutocomplete = status
        }, 100)
      },
      formataInformacoesGrv (log) {
        const isEntidadeRelacionadaComGRV = ['grv', 'detroServiceTask'].some(value => value === log.entity)

        const informacoes = `
          Contrato: ${getLabel(+log.tipoProcesso)}
          Placa: ${log.placa || '-'}
          Placa Original: ${log.placaOriginal || '-'}
          GRV: ${log.numero}`

        return isEntidadeRelacionadaComGRV ? informacoes : '---'
      },
      openRespostaLog (log) {
        this.logSelecionado = log
        this.showRespostaLog = true
      },
      closeRespostaLog () {
        this.logSelecionado = null
        this.showRespostaLog = false
      }
    },
    watch: {
      filtros: function (val) {
        console.log('Mudou')
      }
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    Logs <span class="badge">{{pagination.totalItems}}</span>
                  </h1>
                  <small class="text-muted">
                    <!--<ordenar-arrematante></ordenar-leilao>-->
                  </small>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="text-right text-left-xs">
                  </div>
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="wrapper clearfix">
                <div class="col-sm-7 m-b-xs">
                  <div class="col-md-6">
                    <div class="input-group">
                      <div class="input-group-btn">
                        <a class="btn btn-sm btn-default"><span class="m-r-xs font-bold"></span>Períodos</a>
                      </div>
                      <!--<label class="title_filter " for="filtroData">Data dos Logs</label>-->
                      <select id="filtroData" @change="reloadData" v-model="filtros.data" class="input-sm form-control">
                        <option :value="null">
                          Qualquer data
                        </option>
                        <option :value="'Hoje'">Hoje</option>
                        <option :value="'7dias'">Últimos 7 dias</option>
                        <option :value="'Mes'">Este mês</option>
                        <option :value="'Ano'">Este ano</option>
                        <option :value="'Periodo'">Período</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <!--<label class="title_filter" for="grvplaca">GRV/PLACA</label>-->
                    <!-----------TODO: Componente separado---------------------------------------->
                    <div class="input-group">
                      <div class="autocomplete-input">
                        <input class="form-control" type="text" id="entitytitulo" @blur="setVisibilityOptionsAutocomplete(false)" @keyup="getListaGrvs" v-model="filtroInput.titulo" placeholder="Placa ou número da GRV">
                        <input class="form-control" type="hidden" id="entityid" @blur="setVisibilityOptionsAutocomplete(false)" @keyup="getListaGrvs" v-model="filtroInput.id">
                        <span class="input-group-btn">
                          <button class="btn btn-sm btn-info btn-default" @click="reloadData" type="button">Buscar</button>
                        </span>
                        <ul class="list-group" v-show="showOptionsAutocomplete">
                          <li class="text-center" v-if="loading"><i class="fa fa-spinner fa-spin"></i></li>
                          <li class="text-danger" v-else-if="!listaGrvs.length">Grv não encontrada</li>
                          <li @click="setFiltroInput(item)" v-for="item in listaGrvs" :key="item.id" v-else>{{item.numero}} - {{item.tipoProcesso === 1 ? item.PlacaOriginal : item.placa}}</li>
                        </ul>
                      </div>
                    </div>
                    <!---------------------------------------------------------------------------->
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="input-group">
                    <div class="input-group-btn">
                      <a class="btn btn-sm btn-default"><span class="m-r-xs font-bold"></span>Buscar</a>
                    </div>
                    <input type="text" class="input-sm form-control" v-model="filtros.busca" @keyup="pesquisar"
                           placeholder="Pesquisar">
                  </div>
                </div>
                <div class="row m-l-xs m-r-xs" v-if="filtros.data === 'Periodo'">
                  <div class="col-md-6 filtros-periodo-datas form-group">
                    <input id="filtroData1" placeholder="dd/mm/yyyy"
                           v-model="filtros.data1"
                           v-mask="'##/##/####'" type="text" class="form-control"/>
                    <span class="m-l m-r">até</span>
                    <input id="filtroData2" placeholder="dd/mm/yyyy"
                           v-model="filtros.data2"
                           v-mask="'##/##/####'" type="text" class="form-control"/>
                    <button class="btn btn-sm btn-info m-l" @click="reloadData" :disabled="!filtros.data1 || !filtros.data2">Pesquisar</button>
                  </div>
                </div>
              </div>
              <!--<div class="wrapper m-b-n m-t-n text-right">
                <u-pagination @changePage="changePage" :atual="pagination.atualPage"
                              :total="pagination.totalPages"></u-pagination>
              </div>-->
              <div class="hidden-print">
                <div class="panel wrapper-lg m-t-n" v-show="showFiltros">
                  <div class="r-table-content_ m-t-n">
                    <div class="row">
                      <div class="col-sm-6">
                        <div>Tipo de Pessoa:</div>

                      </div>
                      <div class="col-sm-6">
                        <div>Situação:</div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-hover table-striped b-t b-light">
                  <thead>
                  <tr>
                    <th>Data</th>
                    <th>Método</th>
                    <th>Descrição</th>
                    <th>Informacões GRV</th>
                    <th>Resposta</th>
                    <th>Status</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- FAKE -->
                  <tr v-if="isLoading" v-for="i in [1,2,3]">
                    <td class="v-middle">
                      <u-fake-loader width="100px" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <a class="text-cap custom-link ">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </a>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                  </tr>
                  <!-- ngRepeat: log in logs| limitTo: 10 -->
                  <tr v-for="log in filteredData">
                    <td class="v-middle">{{ moment(log.date.date).format('DD/MM/YYYY HH:mm')}}</td>
                    <td class="v-middle" role="button" tabindex="0">
                      {{ log.method }}
                    </td>
                    <td class="v-middle" role="button" tabindex="0">
                      {{ log.description }}
                    </td>
                    <td style="white-space: pre-wrap; text-align: left">{{formataInformacoesGrv(log)}}</td>
                    <td class="v-middle">
                      <u-button class="btn btn-info btn-xs" @click="openRespostaLog(log)" v-if="log.method !== 'excluirTask'"><i class="fa fa-eye"></i> Ver resposta</u-button>
                    </td>
                    <td class="v-middle" role="button" tabindex="0">
                      <span v-if="+log.status === 0" class="alert-danger" style="padding:5px">FALHA</span>
                      <span v-if="+log.status === 1" class="alert-success" style="padding:5px">SUCESSO</span>
                    </td>
                  </tr><!-- end ngRepeat: log in logs| limitTo: 10 -->

                  <tr v-if="!filteredData || filteredData.length === 0">
                    <td colspan="6">Nenhum registro encontrado</td>
                  </tr>

                  </tbody>
                </table>
              </div>
              <footer class="panel-footer">
                <div class="row">
                  <div class="col-sm-4 hidden-xs">
                    Mostrar:
                    <select @change="changePage(1)" v-model="pagination.limit"
                            class="input-sm form-control w-auto inline v-middle">
                      <option v-for="p in paginationLimits" :value="p">{{ p }}</option>
                    </select>
                    por página
                  </div>
                  <div class="col-sm-2 text-center">
                    <small class="text-muted inline m-t-sm m-b-sm ">{{ pagination.atualPage }} / {{
                      pagination.totalPages
                      }}
                    </small>
                  </div>
                  <div class="col-sm-6 text-right text-center-xs">
                    <u-pagination @changePage="changePage" :atual="pagination.atualPage"
                                  :total="pagination.totalPages"></u-pagination>
                  </div>
                </div>
              </footer>
            </div>

          </div>
        </div>
        <!-- /.col -->
      </div>
      <popup-viewer v-if="showRespostaLog" @close="closeRespostaLog">
        <div class="wrapper-md" style="word-wrap: break-word">
          <ul>
            <li v-if="logSelecionado.response.Guarda">{{ logSelecionado.response.Guarda.Transacao }} - GUARDA: {{ logSelecionado.response.Guarda.Retorno }}</li>
            <li v-if="logSelecionado.response.Recolhimento">{{ logSelecionado.response.Recolhimento.Transacao }} - RECOLHIMENTO: {{ logSelecionado.response.Recolhimento.Retorno }}</li>
            <li v-if="logSelecionado.response.dados">BOLETO: {{ logSelecionado.response.dados.status.mensagem }}</li>
            <li v-if="logSelecionado.response.soapEnvelope">BOLETO: {{ logSelecionado.response.soapEnvelope.soapBody[0].ConsultaBoletoPagoByNrBoletoResponse[0].ConsultaBoletoPagoByNrBoletoResult }}</li>
            <li v-if="logSelecionado.response[0]">RESPOSTA: {{ logSelecionado.response}}</li>
            <li v-if="logSelecionado.response.grv">{{ logSelecionado.response.grv.Guarda.Transacao}} - GRV GUARDA: {{ logSelecionado.response.grv.Guarda.Retorno}}</li>
            <li v-if="logSelecionado.response.grv">{{ logSelecionado.response.grv.Recolhimento.Transacao}} - GRV RECOLHIMENTO: {{ logSelecionado.response.grv.Recolhimento.Retorno}}</li>
            <li v-if="logSelecionado.response.grve">GRVE: {{ logSelecionado.response.grve}}</li>
            <li v-if="logSelecionado.response.Retorno">{{ logSelecionado.response.Transacao}} - RESPOSTA: {{ logSelecionado.response.Retorno}}</li>
          </ul>
        </div>
      </popup-viewer>
    </div>
  </transition>
</template>

<style scoped>
  .filtros-periodo-datas {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* Raphael */
  .autocomplete-input {
    position: relative;
  }
  .autocomplete-input input {
    width: 70%;
    float: left;
  }
  .autocomplete-input ul {
    position: absolute;
    border: #999 1px solid;
    list-style-type: none;
    width: 70%;
    max-height: 100px;
    overflow: auto;
    background-color: #fff;
    z-index: 99;
  }
  .autocomplete-input ul li {
    padding: 5px;
    cursor: pointer;
  }
  .autocomplete-input ul li:hover {
    background-color: #fff;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// Logs.vue?70c786e1